import { Redirect, Route as RouteComponent, Switch } from 'react-router-dom'

import { Security } from 'common/security/security'
import { Agent } from 'modules/Monitoring/agent'
import { RtmPermissionsGate } from 'modules/Monitoring/components/RtmPermissionsGate/RtmPermissionsGate'
import { Route } from 'modules/Monitoring/consts/routes'
import { Monitoring } from 'modules/Monitoring/Monitoring'
import { Root } from 'modules/Monitoring/Root'
import { Ticket } from 'modules/Monitoring/ticket'

const getDefaultRoute = () => {
  if (Security.canViewQueueHealth) {
    return Route.Ticket
  }
  if (Security.canViewAgentAttendance) {
    return Route.Agent
  }

  return Route.Ticket
}

export const MonitoringRoutes = () => {
  const defaultMonitoringRoute = getDefaultRoute()

  return (
    <Root>
      <Monitoring>
        <Switch>
          <RouteComponent path={Route.Monitoring} exact>
            <Redirect to={defaultMonitoringRoute} />
          </RouteComponent>

          <RouteComponent path={Route.Ticket} exact>
            <RtmPermissionsGate permissions={['analytics.view.queues.details.list']}>
              <Ticket />
            </RtmPermissionsGate>
          </RouteComponent>

          <RouteComponent path={Route.Agent} exact>
            <RtmPermissionsGate
              permissions={['analytics.view.agents.attendance.details.list']}
            >
              <Agent />
            </RtmPermissionsGate>
          </RouteComponent>

          <Redirect to={defaultMonitoringRoute} />
        </Switch>
      </Monitoring>
    </Root>
  )
}
